import React from 'react';
import { bool, shape, string } from 'prop-types';

const Machinery = ({
  className = '',
  notUseClass = false,
  style = { color: '#9A6412' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M17 6H20.6182L23 10.7637V15C23 16.1046 22.1046 17 21 17C21 18.66 19.66 20 18 20C17.8961 20 17.7935 19.9947 17.6924 19.9844C16.1776 19.8309 15 18.5561 15 17H9C9 18.66 7.66 20 6 20C4.34 20 3 18.66 3 17H1V10H15V4H17V6ZM6 16C5.45 16 5 16.45 5 17C5 17.55 5.45 18 6 18C6.55 18 7 17.55 7 17C7 16.45 6.55 16 6 16ZM18 16C17.45 16 17 16.45 17 17C17 17.55 17.45 18 18 18C18.55 18 19 17.55 19 17C19 16.45 18.55 16 18 16ZM3 15H3.78027C4.33027 14.3901 5.11007 14 6 14V12H3V15ZM8 14.7793C8.07675 14.8491 8.1501 14.9228 8.21973 15H10V12H8V14.7793ZM12 15H15V12H12V15ZM17 14.1738C17.3131 14.0631 17.649 14 18 14C18.8874 14 19.6822 14.3876 20.2314 15H21V11L19.5 8H17V14.1738Z" fill="currentColor" />
    <path d="M13 7V9H3V7L4 6H12L13 7Z" fill="currentColor" />
  </svg>
);

Machinery.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Machinery;
